export const ACTION_BUTTON_COLOR = 'green';
export const ACTION_BUTTON_APPEREANCE = 'outlined';
export const ACTION_BUTTON_SIZE = 'small';
export const MOCK_MESSAGE_KEY = 'test';
